import { Currency } from '@/core/currency/interfaces';

const ZAR: Currency = {
    name: 'South African Rand',
    demonym: 'South African',
    majorSingle: 'Rand',
    majorPlural: 'Rand',
    codeNumeric: '710',
    symbol: 'R',
    symbolNative: 'R',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ZAR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ZAR;
